import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import type { RelatedCodeItem } from '../../interface/codes';
import { ADD_CODE_DIALOG as D, INK_SOFT, TX_LABEL_COLOR } from '../../styles/tokens';

export const relatedCodeTag = (code: RelatedCodeItem): string | null => {
  const parts = [code.specialty, code.dos].filter(
    (part): part is string => typeof part === 'string' && part.trim().length > 0
  );
  return parts.length > 0 ? parts.join(' · ') : null;
};

export type RelatedCodesListProps = {
  readonly codes: readonly RelatedCodeItem[];
  readonly onSelect: (code: RelatedCodeItem) => void;
};

export const RelatedCodesList: React.FC<RelatedCodesListProps> = ({ codes, onSelect }) => {
  if (codes.length === 0) return null;
  return (
    <Box mt={D.sectionGap}>
      <Text fontSize={D.labelSize} fontWeight={D.labelWeight} letterSpacing={D.labelSpacing} color={TX_LABEL_COLOR} mb={D.labelGap}>
        FROM OTHER CASES ON THIS STAY
      </Text>
      <Box borderWidth="1px" borderColor={D.rule} borderRadius={D.controlRadius} overflow="hidden">
        {codes.map((code) => {
          const tag = relatedCodeTag(code);
          return (
            <Flex
              key={code.code}
              as="button"
              type="button"
              w="100%"
              align="center"
              gap="10px"
              px="12px"
              py="8px"
              textAlign="left"
              borderBottomWidth="1px"
              borderBottomColor={D.rule}
              _last={{ borderBottomWidth: 0 }}
              _hover={{ bg: 'gray.50' }}
              onClick={() => onSelect(code)}
            >
              <Text as="span" fontFamily="mono" fontSize="12px" fontWeight={600} bg={D.relatedCodeBg} color={D.relatedCodeInk} px="7px" py="3px" borderRadius="4px">
                {code.code}
              </Text>
              <Text as="span" flex="1" fontSize="12.5px" color={INK_SOFT}>
                {code.description}
              </Text>
              {tag && (
                <Text as="span" fontSize="xs" borderWidth="1px" borderRadius="sm" px={2}>
                  {tag}
                </Text>
              )}
            </Flex>
          );
        })}
      </Box>
    </Box>
  );
};
